module.exports = __webpack_public_path__ + "static/media/empty-rewards.9f9576a0.svg";